import { applyFilter, applySearchFilter } from '../../Utils/Utils';

export const applyFilters = ({ list, filters }) => {
  let filteredList = list;
  // filter on status
  filteredList = applyFilter({
    list: filteredList,
    filters,
    rowName: 'active',
    defaultFilter: []
  });
  // filter on commercialProductName
  filteredList = applyFilter({
    list: filteredList,
    filters,
    rowName: 'person',
    defaultFilter: []
  });
  // query filter on field: id, code, fullName
  filteredList = applySearchFilter({
    list: filteredList,
    filters,
    rowNames: ['code', 'id', 'fullName']
  });

  return filteredList;
};
